import { simpleSet } from '@r/reducers/utils';

const setCalculationModeHingesSearchText = simpleSet as
  redux.reducers.calculationMode.settings.materials.hinges.searchText;

export const searchText = setCalculationModeHingesSearchText(
  'SET_CALCULATION_MODE_HINGES_SEARCH_TEXT',
  ''
);
